import * as React from 'react';
const SvgMovie = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="m16.444 3.473.041.128.443 1.544a.6.6 0 0 1-.336.718l-.077.027-8.617 2.47 8.964.002c.305 0 .557.226.597.52l.006.082v6.827a2.21 2.21 0 0 1-2.075 2.205l-.135.004H5.215a2.21 2.21 0 0 1-2.205-2.075l-.005-.134V9.049l-.419-1.463a2.21 2.21 0 0 1 1.387-2.691l.128-.041 9.652-2.768a2.21 2.21 0 0 1 2.691 1.387m-.185 6.093H4.21v6.225c0 .485.345.89.802.984l.1.015.103.005h10.04c.52 0 .948-.395 1-.902l.005-.102zM5.635 5.668l-1.202.344c-.5.143-.802.641-.712 1.142l.023.1.277.965.237-.068zm3.82-1.096-2.183.626L5.896 7.68l2.183-.626zm3.822-1.096-2.183.626-1.376 2.483L11.9 5.96zm1.484-.188L13.54 5.49l2.064-.591-.276-.965c-.086-.3-.3-.53-.566-.645"
    />
  </svg>
);
export default SvgMovie;
